import { isCorrectDate } from 'globals/utils';
import { RangeInput } from '@material-ui/pickers';

export const isProperDateRange = (dateRange: RangeInput<Date>): boolean => {
  const validDateRange = dateRange.filter(
    (date) => date != null && isCorrectDate(date)
  );
  return validDateRange.length === 2;
};

const getStartDate = (): Date => {
  const d = new Date();
  d.setMonth(d.getMonth() - 3);
  d.setHours(0, 0, 0);
  d.setMilliseconds(0);
  return d;
};

const getEndDate = (): Date => {
  return new Date();
};

export const getInitialDateRange = (): RangeInput<Date> => {
  const start = getStartDate();
  const end = getEndDate();
  return [start, end];
};
